import addRelatedClassesToElement from './add-related-classes-to-element';
import removeRelatedClassesFromElement from './remove-related-classes-from-element';
import wrapperMap from './wrapper-map';
import customColors from './custom-colors';

export default {
  addRelatedClassesToElement,
  removeRelatedClassesFromElement,
  wrapperMap,
  ...customColors,
};
